
export class SecurityAlert {
  content: string;
  date: Date;
  photoUrl: string;

  locateUrl: string;
  locateUrlParams: any;

  detailsUrl: string;
  detailsUrlParams: any;
  title: string;
  alertType: AlertType;
  progress: number;
  showImage: boolean;
  count: number = 1; // Aynı mesajın kaç kez geldiğini gösterir, default 1
}
export enum AlertType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning'
}
